import { useAuthModal, useTokenStore } from '@/features/auth/store'

/**
 * Runs an action that needs a session: right away when signed in, otherwise
 * after Log in (the modal switches to Log in and the action waits for it).
 */
export function useSignedInAction() {
  const authModal = useAuthModal()
  const tokenStore = useTokenStore()

  return (action: () => void) => {
    if (tokenStore.isAuthenticated()) {
      action()
      return
    }
    authModal.showAuthModal('login', { then: action })
  }
}
